import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { path } from './path';
import PropTypes from 'prop-types';

/**
 * Will render provided component if user is authenticated, otherwise it will redirect user to login page
 * @param {React.Component} Component: name of the component to send user to
 * @param {Boolean} authenticated
 * @param {Array} rest
 */
const PrivateRoute = ({ component: Component, authenticated, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: path.LOGIN,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

PrivateRoute.propTypes = {
  authenticated: PropTypes.bool,
  component: PropTypes.elementType,
  location: PropTypes.object,
};

export default PrivateRoute;
